import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  newDeliveryOrdersCount: 0, // Track new delivery orders
}

const ordersStaffSlice = createSlice({
  name: "ordersStaff",
  initialState,
  reducers: {
    SET_NEW_DELIVERY_COUNT(state, action) {
      state.newDeliveryOrdersCount = action.payload
    },
    INCREMENT_NEW_DELIVERY_COUNT(state) {
      state.newDeliveryOrdersCount += 1
    },
    RESET_NEW_DELIVERY_COUNT(state) {
      state.newDeliveryOrdersCount = 0
    },
  },
})

export const {
  SET_NEW_DELIVERY_COUNT,
  INCREMENT_NEW_DELIVERY_COUNT,
  RESET_NEW_DELIVERY_COUNT,
} = ordersStaffSlice.actions

export default ordersStaffSlice.reducer
